import { render } from "./ReportUserPage.vue?vue&type=template&id=76021b96&ts=true"
import script from "./ReportUserPage.vue?vue&type=script&lang=ts"
export * from "./ReportUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__